import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck } from "@fortawesome/pro-solid-svg-icons/faCircleCheck";
import { faCircleQuestion } from "@fortawesome/pro-solid-svg-icons/faCircleQuestion";
import { LanguageLocaleEnum, PlayerCareerEntry } from "../../../client/api";
import { translate, TranslatorKeys } from "../../../config/translator";
import RoundedRectangle from "../RoundedRectangle";
import ListItem from "../ListItem";
import NoCareerEntryIcon from "../../../assets/svg/NoCareerEntryIcon";

type CareerEntryItemProps = {
  entry: PlayerCareerEntry;
  formatPeriod: (dateFrom: string, dateTo: string | null) => string;
  l: LanguageLocaleEnum;
};

const CareerEntryItem: React.FC<CareerEntryItemProps> = ({ entry, formatPeriod, l }) => {
  const verifiedBadge = entry.verified ? (
    <FontAwesomeIcon
      icon={faCircleCheck}
      className="text-primary dark:text-primary-dark"
      size="lg"
    />
  ) : (
    <FontAwesomeIcon
      icon={faCircleQuestion}
      className="text-font-600 dark:text-font-600-dark"
      size="lg"
    />
  );

  return (
    <ListItem
      image={entry.image}
      title={entry.teamName}
      subtitle={formatPeriod(entry.dateFrom, entry.dateTo)}
      l={l}
      badgeElement={verifiedBadge}
    />
  );
};

type PlayerCareerPanelProps = {
  titleKey: TranslatorKeys;
  career: PlayerCareerEntry[];
  formatPeriod: (dateFrom: string, dateTo: string | null) => string;
  l: LanguageLocaleEnum;
};

const PlayerCareerPanel: React.FC<PlayerCareerPanelProps> = ({
  titleKey,
  career,
  formatPeriod,
  l
}) => (
  <RoundedRectangle
    className="rounded-xl bg-bg-secondary dark:bg-bg-secondary-dark border border-light-gray dark:border-light-gray-dark"
    hasBorder
    hasTitle
    titleType="upLeft"
    titleKey={titleKey}
  >
    <div className="px-6 xl:px-8 py-4">
      {career.length > 0 ? (
        <div className="flex flex-col">
          {career.map((entry: PlayerCareerEntry, index: number) => (
            <div
              key={entry.id}
              className={`${index < career.length - 1 ? "border-b border-light-gray dark:border-light-gray-dark pb-3" : ""} ${index > 0 ? "pt-3" : ""} -mx-6 xl:-mx-8 pl-4 pr-6 xl:pr-8`}
            >
              <CareerEntryItem
                entry={entry}
                formatPeriod={formatPeriod}
                l={l}
              />
            </div>
          ))}
        </div>
      ) : (
        <div className="flex flex-col justify-center items-center py-8">
          <NoCareerEntryIcon className="w-64 h-auto" />
          <p className="text-sm font-normal text-font dark:text-font-dark mt-4 text-center">
            {translate("noCareerAvailable", l)}
          </p>
        </div>
      )}
    </div>
  </RoundedRectangle>
);

export default PlayerCareerPanel;

